/*
 * @Author: Json Chen
 * @Date: 2021-07-14 17:16:33
 * @LastEditTime: 2021-09-29 15:00:44
 * @LastEditors: Teemo Ding
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/PickupLocations/Components/config.ts
 */

export const weekList = ({ getI18n }) => [
  {
    name: getI18n('general.monday') || '',
    checked: true,
    range: ['08:00', '17:00'],
  },
  {
    name: getI18n('general.tuesday') || '',
    checked: true,
    range: ['08:00', '14:00'],
  },
  {
    name: getI18n('general.wednesday') || '',
    checked: true,
    range: ['08:00', '17:00'],
  },
  {
    name: getI18n('general.thursday') || '',
    checked: true,
    range: ['08:00', '17:00'],
  },
  {
    name: getI18n('general.friday') || '',
    checked: true,
    range: ['08:00', '17:00'],
  },
  {
    name: getI18n('general.saturday') || '',
    checked: true,
    range: ['08:00', '17:00'],
  },
  {
    name: getI18n('general.sunday') || '',
    checked: true,
    range: ['08:00', '17:00'],
  },
];
